export default __webpack_public_path__ + "static/media/UmaPTCategory.3cf0bb06.svg";